// extracted by mini-css-extract-plugin
export default {"overlay":"AddAllessehCollectionModal_overlay__es9-8","bottom-bar":"AddAllessehCollectionModal_bottom-bar__w1vi2","bottomBar":"AddAllessehCollectionModal_bottom-bar__w1vi2"};